import React, { useState } from "react";
import { Button, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../../components/index";
import { snackActions } from "../../../../utils/SnackBarUtils";
import copy from "clipboard-copy";
import { SuittService } from "../../../../services";


function UserProfessionalActivities({
                                      user = {}, getUserInfo = () => {
  }
                                    }) {
  const suittService = new SuittService();
  const [editUser, setEditUser] = useState(user);

  const copyPartnerLinkToClipboard = (data) => {
    copy(data);
    snackActions.success("Скопійовано");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const splittedName = name.split(".");
    if (splittedName.length > 1) {
      setEditUser({
        ...editUser,
        [splittedName[0]]: {
          ...editUser[splittedName[0]],
          [splittedName[1]]: value
        }
      });
    } else {
      setEditUser({ ...editUser, [name]: value });
    }
  };

  const updateUserInfo = async () => {
    const result = await suittService.updateUserInfo({ user: editUser });
    if (!result || !result?.status) return snackActions.error("Щось пішло не так");

    snackActions.success("Дані успішно оновлено");
    getUserInfo();
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      <Grid container sx={{ padding: "10px 0" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={updateUserInfo} variant={"contained"}>Оновити</Button>
        </Grid>
        <Grid item sx={{ textAlign: "left" }} xs={12} sm={12} md={12}>
          <Grid item>
            <Typography component={"b"}
                        variant={"b"}>{"Досягнення у професійній діяльності (за останні 5 років)"}</Typography>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.availabilityOfPublications}
                name={"YEDEBO.availabilityOfPublications"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"1. Наявність не менше п’яти публікацій у періодичних наукових виданнях, що включені до переліку фахових видань України, до наукометричних баз, зокрема Scopus, Web of Science Core Collection"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.availabilityOfPublications)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.availabilityOfOnePatent}
                name={"YEDEBO.availabilityOfOnePatent"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"2. Наявність одного патенту на винахід або п’яти деклараційних патентів на винахід чи корисну модель, включаючи секретні, або наявність не менше п’яти свідоцтв про реєстрацію авторського права на твір"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.availabilityOfOnePatent)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.availabilityOfThePublishedTextbook}
                name={"YEDEBO.availabilityOfThePublishedTextbook"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"3. Наявність виданого підручника чи навчального посібника (включаючи електронні) або монографії (загальним обсягом не менше 5 авторських аркушів), в тому числі видані у співавторстві (обсягом не менше 1,5 авторського аркуша на кожного співавтора)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.availabilityOfThePublishedTextbook)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.availabilityOfPublishedTextbooks}
                name={"YEDEBO.availabilityOfPublishedTextbooks"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"4. Наявність виданих навчально-методичних посібників/посібників для самостійної роботи здобувачів вищої освіти та дистанційного навчання, електронних курсів на освітніх платформах ліцензіатів, конспектів лекцій/практикумів/методичних вказівок/рекомендацій/ робочих програм, інших друкованих навчально-методичних праць загальною кількістю три найменування"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.availabilityOfPublishedTextbooks)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.defenseOfDissertationForScientificDegree}
                name={"YEDEBO.defenseOfDissertationForScientificDegree"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"5. Захист дисертації на здобуття наукового ступеня"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.defenseOfDissertationForScientificDegree)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.scientificGuidance}
                name={"YEDEBO.scientificGuidance"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"6. Наукове керівництво (консультування) здобувача, який одержав документ про присудження наукового ступеня (прізвище, ім’я, по батькові дисертанта, здобутий науковий ступінь, спеціальність, назва дисертації, рік захисту, серія, номер, дата, ким виданий диплом)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.scientificGuidance)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.participationCertificationOfScientificPersonnel}
                name={"YEDEBO.participationCertificationOfScientificPersonnel"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"7. Участь в атестації наукових кадрів як офіційного опонента або члена постійної спеціалізованої вченої ради, або члена не менше трьох разових спеціалізованих вчених рад"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.participationCertificationOfScientificPersonnel)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.performingFunctionsOfSupervisor}
                name={"YEDEBO.performingFunctionsOfSupervisor"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"8. Виконання функцій (повноважень, обов’язків) наукового керівника або відповідального виконавця наукової теми (проекту), або головного редактора/члена редакційної колегії/експерта (рецензента) наукового видання, включеного до переліку фахових видань України, або іноземного наукового видання, що індексується в бібліографічних базах"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.performingFunctionsOfSupervisor)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.workMemberOfExpertCouncil}
                name={"YEDEBO.workMemberOfExpertCouncil"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"9. Робота у складі експертної ради з питань проведення експертизи дисертацій МОН або у складі галузевої експертної ради як експерта Національного агентства із забезпечення якості вищої освіти, або у складі Акредитаційної комісії, або міжгалузевої експертної ради з вищої освіти Акредитаційної комісії, або трьох експертних комісій МОН/зазначеного Агентства, або Науково-методичної ради/науково-методичних комісій (підкомісій) з вищої або фахової передвищої освіти МОН, наукових/науково-методичних/експертних рад органів державної влади та органів місцевого самоврядування, або у складі комісій Державної служби якості освіти із здійснення планових (позапланових) заходів державного нагляду (контролю)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.workMemberOfExpertCouncil)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.internationalScientificProjects}
                name={"YEDEBO.internationalScientificProjects"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"10. Участь у міжнародних наукових та/або освітніх проектах, залучення до міжнародної експертизи, наявність звання “суддя міжнародної категорії”"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.internationalScientificProjects)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.scientificConsultingOfEnterprises}
                name={"YEDEBO.scientificConsultingOfEnterprises"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"11. Наукове консультування підприємств, установ, організацій не менше трьох років, що здійснювалося на підставі договору із закладом вищої освіти (науковою установою)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.scientificConsultingOfEnterprises)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.presenceOfApprobation}
                name={"YEDEBO.presenceOfApprobation"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"12. Наявність апробаційних та/або науково-популярних, та/або консультаційних (дорадчих), та/або науково-експертних публікацій з наукової або професійної тематики загальною кількістю не менше п’яти публікацій"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.presenceOfApprobation)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.conductingTrainingSessions}
                name={"YEDEBO.conductingTrainingSessions"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"13. Проведення навчальних занять із спеціальних дисциплін іноземною мовою (крім дисциплін мовної підготовки) в обсязі не менше 50 аудиторних годин на навчальний рік"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.conductingTrainingSessions)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.studentGuide}
                name={"YEDEBO.studentGuide"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"14. Керівництво студентом, який зайняв призове місце на I або ІІ етапі Всеукраїнської студентської олімпіади (Всеукраїнського конкурсу студентських наукових робіт), або робота у складі організаційного комітету / журі Всеукраїнської студентської олімпіади (Всеукраїнського конкурсу студентських наукових робіт), або керівництво постійно діючим студентським науковим гуртком / проблемною групою; керівництво студентом, який став призером або лауреатом Міжнародних, Всеукраїнських мистецьких конкурсів, фестивалів та проектів, робота у складі організаційного комітету або у складі журі міжнародних, всеукраїнських мистецьких конкурсів, інших культурно-мистецьких проектів (для забезпечення провадження освітньої діяльності на третьому (освітньо-творчому) рівні); керівництво здобувачем, який став призером або лауреатом міжнародних мистецьких конкурсів, фестивалів, віднесених до Європейської або Всесвітньої (Світової) асоціації мистецьких конкурсів, фестивалів, робота у складі організаційного комітету або у складі журі зазначених мистецьких конкурсів, фестивалів); керівництво студентом, який брав участь в Олімпійських, Параолімпійських іграх, Всесвітній та Всеукраїнській Універсіаді, чемпіонаті світу, Європи, Європейських іграх, етапах Кубка світу та Європи, чемпіонаті України; виконання обов’язків тренера, помічника тренера національної збірної команди України з видів спорту; виконання обов’язків головного секретаря, головного судді, судді міжнародних та всеукраїнських змагань; керівництво спортивною делегацією; робота у складі організаційного комітету, суддівського корпусу"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.studentGuide)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.guideTheStudent}
                name={"YEDEBO.guideTheStudent"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"\n" +
                  "15. Керівництво школярем, який зайняв призове місце III—IV етапу Всеукраїнських учнівських олімпіад з базових навчальних предметів, II—III етапу Всеукраїнських конкурсів-захистів науково-дослідницьких робіт учнів — членів Національного центру “Мала академія наук України”; участь у журі III—IV етапу Всеукраїнських учнівських олімпіад з базових навчальних предметів чи II—III етапу Всеукраїнських конкурсів-захистів науково-дослідницьких робіт учнів — членів Національного центру “Мала академія наук України” (крім третього (освітньо-наукового/освітньо-творчого) рівня)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.guideTheStudent)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.presenceOfStatusOfParticipant}
                name={"YEDEBO.presenceOfStatusOfParticipant"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"16. Наявність статусу учасника бойових дій (для вищих військових навчальних закладів, закладів вищої освіти із специфічними умовами навчання, військових навчальних підрозділів закладів вищої освіти)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.presenceOfStatusOfParticipant)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.participationInInternationalOperations}
                name={"YEDEBO.participationInInternationalOperations"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"17. Участь у міжнародних операціях з підтримання миру і безпеки під егідою Організації Об’єднаних Націй (для вищих військових навчальних закладів, закладів вищої освіти із специфічними умовами навчання, військових навчальних підрозділів закладів вищої освіти)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.participationInInternationalOperations)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.participationInInternationalMilitaryExercises}
                name={"YEDEBO.participationInInternationalMilitaryExercises"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"18. Участь у міжнародних військових навчаннях (тренуваннях) за участю збройних сил країн — членів НАТО (для вищих військових навчальних закладів, військових навчальних підрозділів закладів вищої освіти)"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.participationInInternationalMilitaryExercises)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.activityBySpecialty}
                name={"YEDEBO.activityBySpecialty"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"19. Діяльність за спеціальністю у формі участі у професійних та/або громадських об’єднаннях"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.activityBySpecialty)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <TextField
                value={editUser.YEDEBO.practicalExperience}
                name={"YEDEBO.practicalExperience"}
                onChange={handleInputChange}
                rows={15}
                fullWidth={true}
                helperText={"20. Досвід практичної роботи за спеціальністю (спеціалізацією)/професією не менше п’яти років (крім педагогічної, науково-педагогічної, наукової діяльності) із зазначенням посади та строку роботи на цій посаді. Організаційна робота у закладах освіти на посадах керівника (заступника керівника) закладу освіти/інституту/факультету/відділення (наукової установи)/ філії/кафедри або іншого відповідального за підготовку здобувачів вищої освіти підрозділу/відділу (наукової установи)/навчально-методичного управління (відділу)/лабораторії/іншого навчально-наукового (інноваційного) структурного підрозділу/вченого секретаря закладу освіти (факультету, інституту)/відповідального секретаря приймальної комісії та його заступника"}
                multiline={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                                    onClick={() => copyPartnerLinkToClipboard(editUser.YEDEBO.practicalExperience)}>
                      <IconButton edge="end" color="primary">
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{display: 'flex', justifyContent: 'flex-end', marginTop: 1}}>
          <Button onClick={updateUserInfo} variant={"contained"}>Оновити</Button>
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
}

export default UserProfessionalActivities;
